import { Link } from 'react-router-dom';
import React from "react";
import '.././css/button.css';
import Navigation from "../component/Navigation";
import Footer from "../component/Footer";
import ".././css/aboutUs.css"; 



 
function AboutUsPage() {
    document.title = 'Hvem er vi?';
    //document.getElementsByTagName('meta')["keywords"].content = "keywords!!";
    document.getElementsByTagName('meta')["description"].content = "Hvem er vi?!";

    return (
        <div>
            <Navigation />
                <div className='aboutBodyUs'>
                     <div className="innerContainerUs">
                        <h2 class="aboutheading">Hvem er vi?</h2>
                            <p className="Abouttext">
                            It is a long established fact that a reader will be
                            distracted by the readable content of a page when 
                            looking at its layout. The point of using Lorem Ipsum 
                            is that it has a more-or-less normal distribution of
                            letters, as opposed to using 'Content here, content 
                            here', making it look like readable English. Many 
                            desktop publishing packages and web page editors now 
                            use Lorem Ipsum as their default model text, and a search
                            for 'lorem ipsum' will uncover many web sites still in their
                            infancy. Various versions have evolved over the years, sometimes
                            by accident, sometimes on purpose (injected humour and the like).
                            </p>
                            
                            <h2 class="aboutheading">Server</h2>
                            <p className="Abouttext">
                                Vi har server og de er meget gode, og alle kan lide dem fordi de er så sindsyg gode, og derfor skal alle personer i verden købe dem
                                Vi har server og de er meget gode, og alle kan lide dem fordi de er så sindsyg gode, og derfor skal alle personer i verden købe dem
                                Vi har server og de er meget gode, og alle kan lide dem fordi de er så sindsyg gode, og derfor skal alle personer i verden købe dem
                                Vi har server og de er meget gode, og alle kan lide dem fordi de er så sindsyg gode, og derfor skal alle personer i verden købe dem
                            </p>
                          
                        </div>
                        {/* <div className="team">
                              <p><b>Vores team</b></p>
                            <div class="navn item-1"> Julius</div>
                            <div class="navn item-2"> Oscar</div>
                            <div class="navn item-3"> Simon</div>
                            <div class="navn item-3"> Lucas Sylvester</div>
                            <div class="navn item-3"> Lucas</div>
                            <div class="navn item-3"> Muhammad</div>
                      </div>*/}
                  
                </div>
            <Footer />
        </div>
    );
}

export default AboutUsPage;


